import { FC } from 'react';
import { TextField, Tooltip } from '@mui/material';
import type { KeyboardEvent as ReactKeyboardEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { TaskCheckBox } from '../../common/TaskCheckBox';
import './TaskTitleSection.scss';
import { getCssVariable } from '../../../utils/styles/styles';

interface TaskTitleSectionProps {
  title: string;
  isReadOnly?: boolean;
  completed?: boolean;
  onTitleChange: (value: string) => void;
  onTitleKeyDown?: (event: ReactKeyboardEvent<HTMLInputElement>) => void;
  onCompletedChange?: (completed: boolean) => void;
  showCheckbox?: boolean;
  disabledTooltipTitle?: string;
  autoFocus?: boolean;
  onFocus?: () => void;
  onBlur?: () => void;
}

export const TaskTitleSection: FC<TaskTitleSectionProps> = ({
  title,
  isReadOnly,
  completed = false,
  onTitleChange,
  onTitleKeyDown,
  onCompletedChange,
  showCheckbox = false,
  disabledTooltipTitle,
  autoFocus = true,
  onFocus,
  onBlur,
}) => {
  const { t } = useTranslation();
  const checkbox = showCheckbox && onCompletedChange && (
    <TaskCheckBox
      isCompleted={completed}
      onChange={onCompletedChange}
      disabled={isReadOnly || !!disabledTooltipTitle}
      className="task-title-section__checkbox"
      size={34}
      color={completed ? getCssVariable('--color-primary') : getCssVariable('--color-black')}
    />
  );

  return (
    <div className="task-title-section">
      {disabledTooltipTitle && checkbox ? (
        <Tooltip title={disabledTooltipTitle} arrow>
          <div>{checkbox}</div>
        </Tooltip>
      ) : (
        checkbox
      )}
      <TextField
        placeholder={t('task.modal.titlePlaceholder')}
        value={title}
        onChange={(event) => onTitleChange(event.target.value)}
        variant="standard"
        className="task-title-section__input"
        autoFocus={autoFocus}
        onKeyDown={onTitleKeyDown}
        onFocus={onFocus}
        onBlur={onBlur}
        disabled={isReadOnly}
        fullWidth
      />
    </div>
  );
};
